import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthChecker = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated && user?.email_verified) {
      navigate("/home");
    } else {
      navigate("/authentication/sign-in");
    }
  }, [isAuthenticated, user, isLoading]);

  return <></>;
};
